






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Map } from 'mapbox-gl';
import BuildingCard from '@/components/molecules/BuildingCard.vue';
import EdgeMarker from '@/components/atoms/EdgeMarker.vue';
import ProgressBar from '@/components/atoms/ProgressBar.vue';
import MapboxEdgeMarker from '@/lib/map/MapboxEdgeMarker';
import { Building, Catalogue } from '@/types';
import {
  DoceboCatalogueView,
  DoceboEnrolmentItemCourse,
  DoceboEnrolmentItemLearningPlan,
} from '@/lib/DoceboAPI';

@Component({
  components: {
    BuildingCard,
    EdgeMarker,
    ProgressBar,
  },
})
export default class MapBuilding extends Vue {
  @Prop() map!: Map;

  @Prop() building!: Building;

  @Prop() zoom!: number;

  private marker: MapboxEdgeMarker | null = null;

  private get isSmall(): boolean {
    return this.zoom < 4;
  }

  private get catalogues(): Catalogue[] {
    return this.$store.getters[
      'catalogues/getConditionalCataloguesForBuilding'
    ](this.building.id);
  }

  private get mandatoryCatalogueId(): number | undefined {
    const mandatoryCatalogueId = this.catalogues.find(
      (catalogue) => catalogue.mandatory
    )?.doceboCatalogueId;
    return mandatoryCatalogueId || undefined;
  }

  private get mandatoryCatalogueView(): DoceboCatalogueView | undefined {
    if (this.mandatoryCatalogueId) {
      return this.$store.state.catalogues.catalogueViews[
        this.mandatoryCatalogueId
      ];
    }
    return undefined;
  }

  private get mandatoryEnrolments(): {
    learningPlanEnrolments: {
      [enrolmentId: string]: DoceboEnrolmentItemLearningPlan;
    };
    courseEnrolments: {
      [enrolmentId: string]: DoceboEnrolmentItemCourse;
    };
  } {
    if (!this.mandatoryCatalogueId)
      return {
        learningPlanEnrolments: {},
        courseEnrolments: {},
      };
    return this.$store.getters['enrolments/getEnrolmentStatusesByCatalogueId'](
      this.mandatoryCatalogueId
    );
  }

  private get completedMandatoryCourses(): number {
    let completed = 0;
    Object.keys(this.mandatoryEnrolments.courseEnrolments).forEach(
      (enrolmentId) => {
        if (
          this.mandatoryEnrolments.courseEnrolments[enrolmentId].status ===
          'completed'
        )
          completed += 1;
      }
    );
    Object.keys(this.mandatoryEnrolments.learningPlanEnrolments).forEach(
      (enrolmentId) => {
        if (
          this.mandatoryEnrolments.learningPlanEnrolments[enrolmentId]
            .status === 'completed'
        )
          completed += 1;
      }
    );
    return completed;
  }

  private get totalMandatoryCourses(): number {
    return this.mandatoryCatalogueView?.data.items.length || 0;
  }

  mounted() {
    const markerEl = this.$refs.buildingCard as HTMLElement;
    const edgeMarker = this.$refs.edgeMarker as EdgeMarker;
    this.marker = new MapboxEdgeMarker(markerEl, edgeMarker);
    this.marker.setLngLat(this.building.markerPosition);
    this.marker.addTo(this.map);
  }

  private beforeDestroy() {
    if (this.marker) this.marker.destruct();
  }

  private onMarkerPressed(e: Event) {
    e.stopPropagation();
    this.$emit('building-pressed', this.building);
  }
}
